import WordEditor from './WordEditor.vue'

const WordEditorPlugin = {
  install(Vue) {
    // 注册为全局组件
    Vue.component('performance-editor', WordEditor)
  }
}

export default WordEditorPlugin
